import { removeSpaceLowerCaseString } from '@mth/utils'

export const testIDs = {
  cancelButton: 'modal-cancel-button',
  positiveCTAButton: (btntitle: string): string => `modal-${removeSpaceLowerCaseString(btntitle)}-button`,
}
